import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map, shareReplay, switchMap } from 'rxjs/operators';

import { SOPS } from 'src/models/sops';
import { SOPS_QUERY } from 'src/graphql/queries/abstraction-layer-queries';

import { SopsBaseService } from './sops.base.service';
import { ApolloService } from './apollo.service';

@Injectable({ providedIn: 'root' })
export class SopsGraphQLService extends SopsBaseService {
	constructor(private apolloService: ApolloService) {
		super();
	}

	public getSOPS(runUid: string): Observable<SOPS> {
		return this.apolloService.abstractionLayerClient$.pipe(
			switchMap(client => {
				return client.query<{ resultsSopsForTestRun: SOPS }>({
					query: SOPS_QUERY,
					variables: { testRunUid: runUid },
				});
			}),
			map(result => {
				const sops = result.data?.resultsSopsForTestRun;
				if (!sops) {
					return new SOPS();
				}
				// The API can return null instead of [] for list fields, so normalize those here
				// rather than relying on every consumer to null-check.
				sops.fpcs ??= [];
				sops.xpcs ??= [];
				sops.functionParameters ??= [];
				return sops;
			}),
			shareReplay(1),
		);
	}
}
